import styled, { keyframes } from 'styled-components';

const pulseOutline = keyframes`
  0%, 100% {
    outline-color: red;
    outline-width: 1px;
  }
  50% {
    outline-color: rgba(255, 0, 0, 0.5);
    outline-width: 2px;
  }
`;

export const PublishStatusStyle = styled.span`
  font-weight: bold;
  font-size: 8px;
  position: absolute;
  left: 15px;
  white-space: nowrap;
  color: ${(props) => props.theme['themeId'] === 'dark'
    ? props.theme['color.white']
    : props.theme['color.text.body']};
`;

export const MarketsTooltip = styled.div`
  position: absolute;
  top: 12px;
  left: 0;
  z-index: 10;
  display: block;
  white-space: normal;
  margin-top: 4px;
  min-width: 165px;
  max-width: 260px;
  padding: 8px;
  border-radius: 8px;
  font-weight: normal;
  font-size: 8px;
  line-height: 1.35;
  background: ${(p) => (p.theme['themeId'] === 'dark'
    ? p.theme['color.blueGreyDarker']
    : p.theme['color.blackLight'])};
  color: ${(p) => p.theme['color.white']};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
`;

export const MarketsTooltipRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  column-gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid ${(p) => p.theme['color.black']};

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  &:first-child {
    padding-top: 0;
  }
`;

export const MarketsTooltipName = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
`;

export const MarketsTooltipStatus = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  min-width: 0;
  white-space: nowrap;
`;

export const MarketsTooltipDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${(p) => p.$color};
`;

export const PublishStatusCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin-top: 2px;
  position: relative;
  outline: ${(props) => props.marketsExist ? '1px solid red' : 'none'};
  outline-offset: 2px;
  animation: ${(props) => props.marketsExist ? pulseOutline : 'none'} 2s ease-in-out infinite;

  &:hover ${MarketsTooltip} {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
`;

export const HollowCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 8px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: relative;
  background: ${(props) => props.theme['color.redLight']};
  color: white;
  overflow: hidden;

  &::before {
    content: "!";
    display: inline-block;
    font-size: 12px;
    font-weight: bolder;
  }
`;
